import { SnackbarProviderProps } from 'notistack';

/**
 * Global options for snackbar provider
 */
export const snackbarOptions: SnackbarProviderProps = {
  maxSnack: 2,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'right',
  },

   classes: {
    containerAnchorOriginBottomRight: "snackbar-position",
  },
  children: [],
};

